import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { DEFAULT_APP_SETTINGS } from "./appSettingsSlice";
import { getCurrentUser } from "../utils/userStorage";

// Get initial user data (active user in current tab)
const initialUser = getCurrentUser();
const isInitialTokenValid = initialUser && initialUser.token && initialUser.userData;

// Get initial app settings from localStorage
const loadAppSettings = () => {
  try {
    const storedSettings = localStorage.getItem('appSettings');
    if (storedSettings) {
      return JSON.parse(storedSettings);
    }
  } catch (error) {
    console.error('Error loading app settings from localStorage:', error);
  }
  
  return { ...DEFAULT_APP_SETTINGS };
};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: {
    auth: {
      user: isInitialTokenValid ? initialUser : null,
      isAuthenticated: isInitialTokenValid,
      tokenExpiry: null,
    },
    appSettings: loadAppSettings(),
  },
});